import React from 'react';
import { ImageLoader } from 'app/interfaces/ImageLoader';

const ImageLoaderContext = React.createContext<ImageLoader>(undefined);

export default ImageLoaderContext;
